"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fins = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var react_1 = require("react");
var framer_motion_1 = require("framer-motion");
var _const_1 = require("../../style");
var _hooks_1 = require("../../hooks");
var FinsContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  max-width: 310px;\n  width: fit-content;\n"], ["\n  max-width: 310px;\n  width: fit-content;\n"])));
var FinsWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  grid-template-rows: 1fr;\n  grid-auto-flow: column;\n  column-gap: 15px;\n\n  justify-content: space-between;\n\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 29px;\n\n  padding: ", "px;\n\n  position: relative;\n  overflow: auto;\n"], ["\n  display: grid;\n  grid-template-rows: 1fr;\n  grid-auto-flow: column;\n  column-gap: 15px;\n\n  justify-content: space-between;\n\n  background: rgba(255, 255, 255, 0.6);\n  border-radius: 29px;\n\n  padding: ", "px;\n\n  position: relative;\n  overflow: auto;\n"])), _const_1.OFFSET_ERROR);
var IndicatorContainer = styled_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  padding: ", "px;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  padding: ", "px;\n"])), _const_1.OFFSET_ERROR);
var Indicator = styled_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n\n  height: 48px;\n  aspect-ratio: 1;\n\n  border-radius: 24px;\n\n  background: #fff;\n"], ["\n  position: absolute;\n\n  height: 48px;\n  aspect-ratio: 1;\n\n  border-radius: 24px;\n\n  background: #fff;\n"])));
/**
 * Fins Component, children should be a list of Fin component
 * @component
 * @example
 * return (
 *   <Fins>
 *     <Fin `props` />
 *     <Fin `props` />
 *     <Fin `props` />
 *   </Fins>
 * )
 */
function Fins(props) {
    var _this = this;
    // prop destruction
    var className = props.className, children = props.children;
    // lib hooks
    var _a = (0, _hooks_1.useFin)(), nextPath = _a.nextPath, indicatorX = _a.indicatorX, initializedGlobal = _a.initialized;
    var triggerEnd = (0, _hooks_1.useFinEnd)()[0];
    var _b = (0, _hooks_1.useFinSetting)(), triggerSetting = _b[0], registerSetting = _b[1];
    var resetFin = (0, _hooks_1.useFinReset)();
    var _c = (0, framer_motion_1.useAnimate)(), scope = _c[0], animate = _c[1];
    // state, ref, querystring hooks
    var _d = (0, react_1.useState)(false), initialized = _d[0], setInitialized = _d[1];
    var containerRef = (0, react_1.useRef)(null);
    // form hooks
    // query hooks
    // calculated values
    // effects
    (0, react_1.useEffect)(function () {
        return function () {
            if (initialized) {
                resetFin();
            }
        };
    }, [initialized]);
    (0, react_1.useEffect)(function () {
        registerSetting(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, animate(scope.current, { x: event.indicatorX, scale: 0.8, opacity: 0 }, { duration: 0 })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, animate(scope.current, { scale: 1, opacity: 1 })];
                    case 2:
                        _a.sent();
                        setInitialized(true);
                        return [2 /*return*/];
                }
            });
        }); });
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (containerRef.current && initializedGlobal) {
            var initialFin = containerRef.current.querySelector('.fin-index--container');
            if (!initialFin)
                throw Error('Need activated Fin component');
            var path = (_a = initialFin.dataset.path) !== null && _a !== void 0 ? _a : '';
            var indicatorX_1 = initialFin.offsetLeft - _const_1.OFFSET_ERROR;
            if (indicatorX_1 < 0)
                indicatorX_1 = 0;
            triggerSetting({
                currentPath: path,
                indicatorX: indicatorX_1,
            });
            triggerEnd({
                currentPath: path,
            });
        }
    }, [containerRef, initializedGlobal]);
    (0, react_1.useEffect)(function () {
        var indicatorAnimation = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, animate(scope.current, {
                            x: indicatorX,
                        })];
                    case 1:
                        _a.sent();
                        if (nextPath) {
                            triggerEnd({
                                currentPath: nextPath,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (initialized) {
            indicatorAnimation();
        }
    }, [indicatorX, initialized]);
    // handlers
    return ((0, jsx_runtime_1.jsx)(FinsContainer, { className: className, ref: containerRef, children: (0, jsx_runtime_1.jsxs)(FinsWrapper, { children: [(0, jsx_runtime_1.jsx)(IndicatorContainer, { children: (0, jsx_runtime_1.jsx)(Indicator, { ref: scope, className: 'indicator' }) }), children] }) }));
}
exports.Fins = Fins;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Fins.js.map